import React, { useCallback, useEffect, useState } from "react";
import {
  deleteNotification,
  getNotifications,
} from "../../services/apis/notification";
import { useAppDispatch, useAppSelector } from "../../store";
import { real_date } from "../../services/convert/date";
import { Eye, Loader2, Trash2 } from "lucide-react";
import ViewNotification from "./view/View";

const Notification = () => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(
    ({ notification }) => notification?.notifications
  );
  const deletingIds = useAppSelector(
    ({ notification }) => notification?.deletingIds || []
  );

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const [selectedNotification, setSelectedNotification] = useState<
    (typeof notifications)[0] | null
  >(null);

  const onLoad = useCallback(() => {
    getNotifications(dispatch);
  }, [dispatch]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  const handleViewNotification = (data: (typeof notifications)[0]) => {
    setSelectedNotification(data);
    setModalOpen(true);
  };

  const isDeleting = (id: number) => deletingIds.includes(id);

  // const isRead = notifications[0]?.seen === "1";

  return (
    <div className="grid divide-y divide-gray-100 rounded-2xl bg-white overflow-hidden">
      {notifications.map((data, i) => {
        return (
          <div
            key={i}
            className="relative flex flex-col sm:flex-row sm:items-center gap-2 hover:bg-gray-100/50 transition-shadow duration-300 px-4 py-4"
          >
            {/* Serial Number */}
            <div className="sm:absolute sm:top-1/2 sm:left-4 sm:-translate-y-1/2 text-xs text-gray-600 font-medium w-8 h-8 bg-primary-100/50 rounded-full grid place-content-center">
              {i + 1}
            </div>

            {/* Subject */}
            <div className="flex-1 flex items-center gap-4 sm:ml-8">
              <p className="text-md font-semibold text-gray-800 mb-0">
                {data.subject}
              </p>
            </div>

            {/* {isRead ? "unseen" : "seen"} */}

            {/* Date + Actions */}
            <div className="flex justify-between sm:justify-normal items-center gap-2 sm:ml-auto">
              <span className="text-xs text-gray-500">
                {real_date(data.created_at)}
              </span>
              <div className="inline-flex items-center gap-2">
                <Eye
                  className="size-4 cursor-pointer"
                  onClick={() => handleViewNotification(data)}
                />
                {isDeleting(data.id) ? (
                  <Loader2 className="size-4 text-red-500 animate-spin" />
                ) : (
                  <Trash2
                    className="size-4 text-red-500 cursor-pointer"
                    onClick={() => deleteNotification(data.id, dispatch)}
                  />
                )}
              </div>
            </div>
          </div>
        );
      })}

      <ViewNotification
        isOpen={modalOpen}
        isClose={() => setModalOpen(false)}
        notification={selectedNotification}
      />
    </div>
  );
};

export default Notification;
